import { AppTheme } from 'containers';
import { SnackbarProvider } from 'notistack';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'services';
import { useDispatch } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { useState, useEffect } from 'react';
import { signIn } from 'reducers/profileSlice';

type ContainerType = {
  children: React.ReactNode;
};

const Container = ({ children }: ContainerType) => {
  const dispatch = useDispatch();

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    try {
      const profile = JSON.parse(localStorage.getItem('profile')!);
      const { exp } = jwtDecode(profile.accessToken) as any;
      if (Date.now() / 1000 < exp - 600) {
        jwtDecode(profile.accessToken);
        dispatch(signIn(profile));
      }
    } catch {
    } finally {
      setIsReady(true);
    }
  }, [dispatch]);

  return (
    <SnackbarProvider
      preventDuplicate={false}
      autoHideDuration={3000}
      variant='success'
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <QueryClientProvider client={queryClient}>
        <AppTheme>{isReady ? children : null}</AppTheme>
      </QueryClientProvider>
    </SnackbarProvider>
  );
};

export default Container;
